export default "__VITE_ASSET__BI8aQ5qU__"